import * as React from 'react';

import AppBar from 'components/AppBar/AppBar';
import { useAccount } from 'catering/context/providers/AccountProvider';
import { getAppBarOwnState } from 'helpers/ownState/AppBarOwnState';

function LocationAppBar() {
  const { logo, logoDestinationUrl, name } = useAccount();
  return (
    <AppBar
      logo={logo}
      logoLinkPath={logoDestinationUrl}
      name={name}
      ownState={{
        appBar: getAppBarOwnState()
      }}
    />
  );
}

export default LocationAppBar;
